/**
 * Copyright (c) 2021 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import { CDocumentChangeStatusFillSoPOptInOptOut } from './document.status.optinoptout.container';

class DocumentStatusOptInOptOutModal extends React.Component {
  render() {
    return (
      <div>
        <CDocumentChangeStatusFillSoPOptInOptOut {...this.props} />
      </div>
    );
  }
}

export default DocumentStatusOptInOptOutModal;
